import { useContext, useEffect, useState } from 'react'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import axios from 'axios'
import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { checkError } from '../utils/utils';
import qs from "qs";
import { api } from "../services/config"
import { ProjectContext } from '../screens/ProjectScreen';
import { useOutletContext } from 'react-router-dom';

function AddTermRelation({
    type = "instance",
    selectedTerms,
    onClose,
}) {
    const type_bulk = (type === "bulk");
    const {
        setTreeState,
        setProjectState,
        termData, setTermData,
        headers,
    } = useContext(ProjectContext);
    const term = termData.id;
    const [termRelated, setTermRelated] = useState(
        (type_bulk && termData?.id)
            ? [termData]
            : []
    )
    const [relationName, setRelationName] = useState('')

    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const [validated, setValidated] = useState(false);

    const [terms, setTerms] = useState([])
    const [query, setQuery] = useState()
    const [loading, setLoading] = useState(false)

    const [checked, setchecked] = useState(false)

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState


    const handleInputChange = query => {
        setTerms([])
        setQuery(query);
    };

    useEffect(() => {
        async function fetchTerms(limit = 10, offset = 0) {
            let params = {
                'surface_regex': query ? `(^${query})` : "",
                'sort': (["reference"]),
                'limit': limit,
                'offset': offset
            };
            await axios.get(
                `${api.project}${projectId}/terms/`,
                {
                    params,
                    paramsSerializer: function (params) {
                        return qs.stringify(params, { arrayFormat: "repeat" });
                    },
                },
                { headers }
            )
                .then(res => {
                    setTerms(res.data.terms)
                    setLoading(true)
                })
                .catch(
                    function (error) {
                        return Promise.reject(error)
                    }
                )
        }
        setLoading(false)
        if (query !== undefined && query.length !== 0) fetchTerms()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])



    const onShowSuccessMessage = (res) => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
            toggleAddRelationPopup(res)
        }, 500)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 2000)
    };


    const formHandleSubmit = event => {
        event.preventDefault();
        setchecked(true)
        if ((term || type_bulk) && termRelated?.[0]?.id && relationName !== '') {
            setValidated(true);
            setchecked(false);
            const term_id = type_bulk ? termRelated?.[0]?.id : term;
            const related = type_bulk ? selectedTerms.map(item => item.id) : [termRelated[0]?.id];

            const relation = {
                term: term_id,
                relation: relationName,
                related,
            }
            axios.post(api.project + projectId + '/terms/' + term_id + '/relation/', relation, { headers })
                .then(checkError)
                .then(res => {
                    onShowSuccessMessage(res);
                    if (termRelated[0].vedette_class && termData.vedette_class) {
                        updateState(res.id, termRelated[0].vedette_class, termData.vedette_class)
                    }
                    else if (termRelated[0].vedette_class) {
                        updateState(res.id, termRelated[0].vedette_class)
                    }
                    else if (termData.vedette_class) {
                        updateState(res.id, termData.vedette_class)
                    }
                })
                .catch(() => {
                    onShowErrorMessage();
                })
        }
    }

    async function toggleAddRelationPopup(res) {
        if (type_bulk) {
            setProjectState(projectState => ({ ...projectState, refresh: !projectState?.refresh }))
            setTermData(res)
            onClose()
        } else {
            setProjectState(projectState => ({ ...projectState, addRelationIsOpen: false, refresh: !projectState?.refresh }))
            setTermData(res)
        }
    }

    async function updateState(relationId, id, idRelated) {
        let res2
        const res = await axios.put(
            `${api.project}${projectId}/sc/`,
            {
                'ids': [id],
            },
            { headers }
        )
        if (idRelated) {
            res2 = await axios.put(
                `${api.project}${projectId}/sc/`,
                {
                    'ids': [idRelated],
                },
                { headers }
            )
            if (res.data.classes[0].hypernyms && res2.data.hypernyms)
                setTreeState({ updatedSemantics: res.data.classes[0].hypernyms.concat(res2.data.classes[0].hypernyms), item: `relation-${relationId}`, })
            else if (res.data.classes[0].hypernyms)
                setTreeState({ updatedSemantics: res.data.classes[0].hypernyms.concat(0), item: `relation-${relationId}`, })
            else if (res2.data.classes[0].hypernyms)
                setTreeState({ updatedSemantics: res2.data.classes[0].hypernyms.concat(0), item: `relation-${relationId}`, })
            else
                setTreeState({ updatedSemantics: [0], item: `relation-${relationId}`, })
        }
        else if (res.data.classes[0].hypernyms)
            setTreeState({ updatedSemantics: res.data.classes[0].hypernyms, item: `relation-${relationId}`, })
        else
            setTreeState({ updatedSemantics: [0], item: `relation-${relationId}`, })
    }

    return (
        <div className=''>
            <Alert className="mx-5" variant="success" show={showSuccess} >
                Relation ajouté avec succès
            </Alert>
            <Alert className="mx-5" variant="danger" show={showError} >
                Une erreur s'est produite lors de la création de la relation !
            </Alert>
            <Form className="mt-3 mx-5" noValidate validated={validated} >
                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Terme{type_bulk ? "s" : ""}
                    </Form.Label>
                    <Col sm="8" xs="12">
                        {
                            type_bulk
                                ? <Typeahead
                                    className={checked && termRelated?.[0] ? "is-invalid" : ""}
                                    isInvalid={checked && termRelated?.[0]}
                                    id="search-related-term"
                                    onChange={setTermRelated}
                                    labelKey="reference"
                                    renderMenu={(results, menuProps) => (
                                        <Menu {...menuProps}>
                                            {results.map((result, index) => (
                                                <MenuItem option={result} position={index}>
                                                    <span>
                                                        {result.reference}
                                                    </span>
                                                    <span className="opacity-50 f-s-13 ">
                                                        {result?.form?.source?.label}
                                                    </span>
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    )}
                                    emptyLabel={!(query !== undefined && query.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                                    options={(query !== undefined && query.length !== 0) ? terms : []}
                                    onInputChange={handleInputChange}
                                    placeholder="Sélectionnez un terme..."
                                    selected={termRelated || []}
                                />
                                : <Form.Control defaultValue={termData.reference} disabled />
                        }
                        <Form.Control.Feedback type="invalid">
                            Veuillez renseigner ce champ.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Terme lié <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Col sm="8" xs="12">
                        {
                            type_bulk
                                ? <Typeahead
                                    id="search-related-term"
                                    labelKey="reference"
                                    renderMenu={(results, menuProps) => (
                                        <Menu {...menuProps}>
                                            {results.map((result, index) => (
                                                <MenuItem option={result} position={index}>
                                                    <span>
                                                        {result.reference}
                                                    </span>
                                                    <span className="opacity-50 f-s-13 ">
                                                        {result?.form?.source?.label}
                                                    </span>
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    )}
                                    selected={selectedTerms || []}
                                    multiple
                                    disabled
                                />
                                : <Typeahead
                                    className={checked && (termRelated?.[0]) ? "is-invalid" : ""}
                                    isInvalid={checked && (termRelated?.[0])}
                                    id="search-related-term"
                                    onChange={setTermRelated}
                                    labelKey="reference"
                                    renderMenu={(results, menuProps) => (
                                        <Menu {...menuProps}>
                                            {results.map((result, index) => (
                                                <MenuItem option={result} position={index}>
                                                    <span>
                                                        {result.reference}
                                                    </span>
                                                    <span className="opacity-50 f-s-13 ">
                                                        {result?.form?.source?.label}
                                                    </span>
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    )}
                                    emptyLabel={!(query !== undefined && query.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                                    options={(query !== undefined && query.length !== 0) ? terms : []}
                                    onInputChange={handleInputChange}
                                    placeholder="Sélectionnez un terme..."
                                    selected={termRelated || []}
                                />
                        }
                        <Form.Control.Feedback type="invalid">
                            {(query && query.length > 0) ? "Veuillez renseigner une valeur existante." : "Veuillez renseigner ce champ."}
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3" controlId="">
                    <Form.Label column sm="4" xs="12">
                        Nom de la relation <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Col sm="8" xs="12">
                        <Form.Control
                            className={checked && (relationName == null || relationName === '') ? "is-invalid" : ""}
                            isInvalid={checked && (relationName == null || relationName === '')}
                            required
                            as='select'
                            value={relationName}
                            onChange={(e) => setRelationName(e.target.value)}
                        >
                            <option value=''>Select...</option>
                            <option value="VARIATE">Variation</option>
                            <option value="ACRONYM">Acronyme</option>
                            <option value="TRANSLT">Traduction</option>
                            <option value="SYNONYM">Synonyme</option>
                            <option value="QUA-SYN">Quasi-Synonyme</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Veuillez renseigner ce champ.
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <div className="text-center"><Button type="submit" onClick={formHandleSubmit}>Ajouter</Button></div>

            </Form>
        </div>
    )
}

export default AddTermRelation